export enum IdentityDocumentTypeEnum {
  RussianPassport = 1,
}
